import React, { Component } from 'react'
import sanitizeHtml from 'sanitize-html'

// CSS
import '../../css/help.css'

class FieldHelp extends Component {
    constructor(props){
        super(props)
        this.state = {
            showHelp: false
        }
    }
    render() {
        const { label, helpItem, noMargin } = this.props

        return (
            <div>
                <label style={noMargin ? {margin: '0'} : {}}>{label}:{helpItem && <span className={'icon-info_outline help-icon' + (this.state.showHelp ? ' active' : '')} onClick={() => this.setState({ showHelp: !this.state.showHelp })}></span>}</label>
                {helpItem &&
                    <div className={'page-help' + (this.state.showHelp ? ' active' : '')} dangerouslySetInnerHTML={{ __html: sanitizeHtml(helpItem.txt) }} />
                }
            </div>
        )
    }
}

export default FieldHelp



// WEBPACK FOOTER //
// ./src/components/utils/FieldHelp.js